import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  DEFAULT_CURRENCY,
  formatDate,
  formatDateTime,
  formatNumber,
  formatPrice,
} from "@prostocheck/shared";

import { LOCALE_DEFS, toLocale } from "../../locales";
import { IFormatters } from "./use-formatters.models";

/**
 * Money and dates have to follow the interface language, so no component may
 * call the raw `libs/shared` formatters — they would stay on `uk-UA` after a
 * language switch. Re-runs on `languageChanged` like any other consumer of
 * `useTranslation`.
 */
export const useFormatters = (): IFormatters => {
  const { i18n } = useTranslation();
  const { intlLocale } = LOCALE_DEFS[toLocale(i18n.resolvedLanguage)];

  return useMemo(
    () => ({
      formatDate: value => formatDate(value, intlLocale),
      formatDateTime: value => formatDateTime(value, intlLocale),
      formatNumber: value => formatNumber(value, intlLocale),
      formatPrice: value => formatPrice(value, DEFAULT_CURRENCY, intlLocale),
    }),
    [intlLocale],
  );
};
